import React, { FunctionComponent } from 'react';

import './Page.scss';

export const Page: FunctionComponent<{}> = (props) => (
    <div className="main_page">
        {props.children}
    </div>
);